import React from 'react'

function Footer(): React.ReactElement | null {
    return null
}

export default Footer